import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import { localize } from '../../utils/TranslationUtils'

import NavbarLink from './NavbarLink'
import styles from './styles'


const decorators = [
  localize,
  memoized,
]

function Navbar(props) {
  const { routesInfos } = props

  return (
    <>
      <ul
        role="menubar"
        className="container"
      >
        {routesInfos.map(routeInfo => (
          <NavbarLink
            key={routeInfo.name}
            route={routeInfo.route}
            routeParams={routeInfo.routeParams}
            link={routeInfo.link}
            label={routeInfo.name}
            selected={routeInfo.active}
            target={routeInfo.route ? '_self' : '_blank'}
          />
        ))}
      </ul>
      <style jsx>{styles}</style>
    </>
  )
}

Navbar.propTypes = {
  routesInfos: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      route: PropTypes.string,
      link: PropTypes.string,
    })
  ).isRequired,
}


Navbar = chainDecorators(decorators, Navbar)

export default Navbar
